module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dedicated-solutions-item"
  }, [_c('div', {
    staticClass: "dedicated-solutions-item-top"
  }, [_c('span', {
    staticClass: "dedicated-solutions-item-name"
  }, [_vm._v("\n      " + _vm._s(_vm.item.NAME) + "\n      "), (!!_vm.item.SUBTITLE) ? _c('span', {
    staticClass: "virtual-solutions-item-name-appointment"
  }, [_vm._v(_vm._s(_vm.item.SUBTITLE))]) : _vm._e(), _vm._v(" "), (!!_vm.item.SOFTWARE) ? _c('span', {
    staticClass: "virtual-solutions-item-name-type"
  }, [_vm._v(_vm._s(_vm.item.SOFTWARE))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-item-label-wrapper"
  }, [(_vm.setLabel) ? _c('span', {
    class: 'dedicated-solutions-item-label ' + _vm.setLabel.class
  }, [_vm._v(_vm._s(_vm.setLabel.name))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dedicated-solutions-item-price desktop"
  }, [_vm._v(_vm._s(_vm.item.PRICES.BASE.DISPLAY) + " ₽/мес.")])]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-item-bottom"
  }, [_c('div', {
    staticClass: "dedicated-solutions-item-props"
  }, [(_vm.item.PROPERTIES.CPU.VALUE) ? _c('span', {
    staticClass: "dedicated-solutions-item-prop"
  }, [_vm._v("\n          " + _vm._s(_vm.components.CPU[_vm.item.PROPERTIES.CPU.VALUE].NAME) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.item.PROPERTIES.RAM.VALUE) ? _c('span', {
    staticClass: "dedicated-solutions-item-prop"
  }, [_vm._v("\n          " + _vm._s(_vm.components.RAM[_vm.item.PROPERTIES.RAM.VALUE].NAME) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.disksList), function(disk) {
    return _c('span', {
      staticClass: "dedicated-solutions-item-prop"
    }, [_vm._v("\n          " + _vm._s(disk.COUNT) + " × " + _vm._s(disk.NAME) + "\n      ")])
  }), _vm._v(" "), (_vm.item.PROPERTIES.RAID.VALUE) ? _c('span', {
    staticClass: "dedicated-solutions-item-prop"
  }, [_vm._v("\n          " + _vm._s(_vm.components.RAID[_vm.item.PROPERTIES.RAID.VALUE].NAME) + "\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-item-buy"
  }, [_c('div', {
    staticClass: "dedicated-solutions-item-price mobile"
  }, [_vm._v(_vm._s(_vm.item.PRICES.BASE.DISPLAY) + " ₽/мес.")]), _vm._v(" "), _c('div', {
    staticClass: "dedicated-solutions-item-button"
  }, [_c('div', {
    staticClass: "btn ripple",
    on: {
      "click": function($event) {
        return _vm.add2basket(_vm.item.ID)
      }
    }
  }, [_vm._v("Выбрать")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25a51327", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25a51327!./~/vue-loader/lib/selector.js?type=template&index=0!./depohost.ru/local/vue.js/v-dedicated-solution-item/v-dedicated-solution-item.vue
// module id = 23
// module chunks = 0